import React from 'react';
import './styles.css';

const QLoadingSpinner = () => (<div className="spinner" ><div className='spinnerRadius'>Loading...</div></div >)

export default QLoadingSpinner;